import { Grid } from "@mui/material";
import {
  CommonButton,
  CustomRequiredInputLabel,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import { ValidationError, object, string } from "yup";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";

const DailyCheckReceiptReport = ({ sendDataToParent, getReportData }: any) => {
  interface ErrorMessageTypesDailyCheck {
    searchbydate: string;
  }

  const formFieldsDailyChkReceipt = {
    searchbydate: dayjs().format("MM-DD-YYYY"),
  };

  const validationSchemaForpooja = object().shape({
    searchbydate: string().required("Select Date is required"),
  });

  const errors: ErrorMessageTypesDailyCheck = {
    ...formFieldsDailyChkReceipt,
  };

  const [errorMessageDailyCheck, setErrorMessageDailyCheck] =
    useState<ErrorMessageTypesDailyCheck>({ ...formFieldsDailyChkReceipt });

  const [formDataDailyChkReceipt, setFormDataDailyChkReceipt] = useState(
    formFieldsDailyChkReceipt
  );
  const [isDatePickerFromOpen, setDatePickerFromOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDateChange = (field: any, value: any) => {
    const formattedDate = dayjs(value, "MM/DD/YYYY");
    setFormDataDailyChkReceipt({
      ...formDataDailyChkReceipt,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM/DD/YYYY")
        : "",
    });
  };

  useEffect(() => {
    setDatePickerFromOpen(false);
  }, [formDataDailyChkReceipt.searchbydate]);

  const handlSubmitDailyCheckReceiptReport = async () => {
    try {
      // Validate the form data against the validation schema
      await validationSchemaForpooja.validate(formDataDailyChkReceipt, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessageDailyCheck(errors);
      // Call your API or perform other actions here
      // saveApiCall();
      getDailyCheckReceiptReport();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesDailyCheck] = e.message;
          }
        });
      }
      setErrorMessageDailyCheck(errors);
    }
  };

  const getDailyCheckReceiptReport = () => {
    const reqBody = {
      searchStartDate: formDataDailyChkReceipt.searchbydate,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/treasury/DAILY_CHECK_RECEIPT_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true,{reqBody:reqBody});
        const response = res.data.map((report:any)=>{
          return {
            "Check Number":report.checknumber,
            "BankName":report.bankname,
            "Receipt Number":report.receiptnumber,
            "Name (Sign-in)":`${report.firstname} ${report.middlename} ${report.lastname} (${report.username})`,
            "Donation/Pooja":report.type,
            "Amount":formatAmount(report.amount),
        }
          })
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const DobDatePickerDailyReport = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formDataDailyChkReceipt.searchbydate}
        handleDateChange={handleDateChange}
        name="searchbydate"
        errorMessage=""
        disableFuture
      />
    );
  };

  return (
    <div>
      <Grid container columnSpacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search Date", true)}
          {DobDatePickerDailyReport()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: "10px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitDailyCheckReceiptReport}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
      </Grid>
    </div>
  );
};

export default DailyCheckReceiptReport;
